import clsx from "clsx"
import type { AriaRole } from "react"

import styles from "./Line.module.css"

export interface LineProps {
  color: "grey" | "green" | "amber" | "purple"
  role?: AriaRole
}

export function Line(props: LineProps) {
  const { color, role = "status" } = props

  return <div role={role} className={clsx(styles.root, styles[color])} />
}
